"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var palette_1 = require("../../constants/palette");

var zIndex_1 = require("../../systems/zIndex");

var React = require("react");

var mobile_1 = require("./mobile");

var NavClubInfo_1 = require("./NavClubInfo");

var NavTabs_1 = require("./NavTabs");

var NavLocationInfo_1 = require("./NavLocationInfo");

var MobileHeader_1 = require("./mobile/MobileHeader");

var MobileNav_1 = require("./mobile/MobileNav");

var MobileNavTabs_1 = require("./mobile/MobileNavTabs");

var MobileContactInfo_1 = require("./mobile/MobileContactInfo");

var TabLink_1 = require("./TabLink");

var MobileTabLink_1 = require("./mobile/MobileTabLink");

var StyledDesktopNavigation = styled_components_1.default.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: ", ";\n  background-color: ", ";\n  height: 87px;\n  width: 100%;\n  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.06);\n  border-bottom: solid 1px ", ";\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-around;\n  align-items: center;\n  padding: 0 20px;\n  box-sizing: border-box;\n  @media only screen and (max-width:767px) {\n    display: none;\n  }\n"], ["\n  z-index: ", ";\n  background-color: ", ";\n  height: 87px;\n  width: 100%;\n  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.06);\n  border-bottom: solid 1px ", ";\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-around;\n  align-items: center;\n  padding: 0 20px;\n  box-sizing: border-box;\n  @media only screen and (max-width:767px) {\n    display: none;\n  }\n"])), zIndex_1.default.Header, palette_1.default.white, palette_1.default.lightGrey);

var Navigation =
/** @class */
function (_super) {
  __extends(Navigation, _super);

  function Navigation(props) {
    var _this = _super.call(this, props) || this;

    _this.renderDesktopLinks = _this.renderDesktopLinks.bind(_this);
    _this.renderMobileLinks = _this.renderMobileLinks.bind(_this);
    return _this;
  }

  Navigation.prototype.renderDesktopLinks = function () {
    var links = this.props.links;
    if (!links) return null;
    return links.map(function (link) {
      return React.createElement(TabLink_1.default, {
        text: link.text,
        link: link.link,
        key: link.link
      });
    });
  };

  Navigation.prototype.renderMobileLinks = function () {
    var links = this.props.links;
    if (!links) return null;
    return links.map(function (link) {
      return React.createElement(MobileTabLink_1.default, {
        text: link.text,
        link: link.link,
        key: link.link
      });
    });
  };

  Navigation.prototype.render = function () {
    var locationInfo = this.props.locationInfo;
    var logoLink = locationInfo && locationInfo.locationId ? "/locations/" + locationInfo.locationId + "/schedule" : '/';
    if (!locationInfo) return null;
    return React.createElement(React.Fragment, null, React.createElement(StyledDesktopNavigation, null, React.createElement(NavClubInfo_1.default, {
      logoLink: logoLink,
      logo: locationInfo.clubLogoUrl,
      clubName: locationInfo.clubName,
      locationName: locationInfo.locationName
    }), React.createElement(NavTabs_1.default, null, this.renderDesktopLinks()), React.createElement(NavLocationInfo_1.default, {
      address1: locationInfo.address1,
      address2: locationInfo.address2,
      city: locationInfo.city,
      state: locationInfo.state,
      zip: locationInfo.zip,
      phoneNumber: locationInfo.locationPhoneNumber
    })), React.createElement(mobile_1.default, null, React.createElement(MobileHeader_1.default, {
      logo: locationInfo.clubLogoUrl,
      clubName: locationInfo.clubName,
      locationName: locationInfo.locationName
    }), React.createElement(MobileNav_1.default, null, React.createElement(MobileNavTabs_1.default, null, this.renderMobileLinks()), React.createElement(MobileContactInfo_1.default, {
      address1: locationInfo.address1,
      address2: locationInfo.address2,
      city: locationInfo.city,
      state: locationInfo.state,
      zip: locationInfo.zip,
      phoneNumber: locationInfo.locationPhoneNumber
    }))));
  };

  return Navigation;
}(React.Component);

exports.default = Navigation;
var templateObject_1;